import { Badge } from '@cloudflare/kumo';
import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const StopNode = memo((props: NodeProps) => (
  <BaseNode
    {...props}
    description="Finaliza o fluxo para o contato"
    onDelete={props.data.onDelete}
    status={<Badge variant="neutral">Bloco final</Badge>}
    sourceHandles={null}
  />
));

StopNode.displayName = 'StopNode';
